import gql from 'graphql-tag';

interface Result {
  options: string[];
}

export interface OptionsQueryResult {
  getUFs: Result;
  getRaces: Result;
  getStates: Result;
  getRgIssuers: Result;
  getNationalities: Result;
  getCreditCardYears: Result;
  getCreditCardFlags: Result;
}

const genericGqlString = (queryName: string) => {
  return gql`
    query { 
      ${queryName} {
        options
      }
    }
  `;
};

export const getUFs = genericGqlString('getUFs');
export const getRaces = genericGqlString('getRaces');
export const getStates = genericGqlString('getStates');
export const getRgIssuers = genericGqlString('getRgIssuers');
export const getNationalities = genericGqlString('getNationalities');
export const getCreditCardYears = genericGqlString('getCreditCardYears');
export const getCreditCardFlags = genericGqlString('getCreditCardFlags');
